import { request } from "../../utils/config"



export const UPLOAD_FILE = async (body: any) => {
    const response = await request({
      url: "Upload",
      method: "POST",
      data: body,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    })
    return response.data
  }